import {
    GET_CALENDAR_SETTINGS,
    PUT_CALENDAR_SETTINGS,
    GET_CALENDAR_EVENTS,
    CalendarMode,
    PUT_CALENDAR_TIMERANGE,
    GET_BAYES,
    PUT_UNVAILABLE_BAYES,
    GET_CONTRACTS_SLOT,
    PUT_BOOK_SLOT,
    GET_BOOKINGS,
    GET_BOOKING,
    GET_BUSINESS_VEHICLE,
    POST_BOOKING,
    CHANGE_STATUS,
    EntityType,
    BadgeStatus,
    SELECTOR,
    CHECKLIST,
    POST_CLONE_RESERVATION,
    ReservationPostType,
    CalendarViewType,
    DOWNLOAD_DOCUMENT,
    DocumentType,
    NON_WORKING_DAYS,
    LOAD_ADDRESSES_OPTIONS,
    GET_BUSINESS_SETTLE,
    GET_CONTRACTS_SETTLE
} from "shared/constants";

import {
    ICheckListData,
    IBooking,
    ICalendarDay,
    ICalendarDialogFormData,
    ICloneReservation,
    IBillingReport
} from "dataModels/b2b";

import axios from "axios";

//const HOST =  process.env.REACT_APP_HOST_B2B;
const HOST = window&&window._env_?window._env_.REACT_APP_HOST_B2B:process.env.REACT_APP_HOST_B2B;
const MODULE: string = "/b2b";

/* Edit calendar settings */
export const getCalendarSettings = () => {
    return axios.get(HOST + MODULE + GET_CALENDAR_SETTINGS)
}

/* Load calendar settings */
export const putCalendarSettings = (calendarSettingsData: ICalendarDay[]) => {
    return axios.put(HOST + MODULE + PUT_CALENDAR_SETTINGS, calendarSettingsData)
        .then(response => {
            return response;
        })
}

/** Load calendar events */
//draft: 0, 1 per gli slot in draft del calendario provvisorio – 0 per gli slot del calendario pubblico 
//startDate: 0, timestamp 
//viewType: 0, secondo enumeratore sopra 
export const getCalendarEvents = ( calendarType:number, startDate:number, calendarMode:CalendarMode ,forMove:boolean,isCloningIup:string|undefined, queryString?:string) => {
    let queryStr = queryString? queryString :""
    return axios.get(HOST + MODULE + GET_CALENDAR_EVENTS+queryStr, { params: { draft: calendarType, startDate:startDate, viewType:calendarMode, forMove:forMove,codeIup:isCloningIup  } })
    .then(response => {
        return response.data;
    })
}

export const downloadDocument = (entityId: string, entityType: EntityType, documentType: DocumentType) => {
    return axios.get(HOST + MODULE + DOWNLOAD_DOCUMENT, { params: { entityId: entityId, entityType: entityType, documentType: documentType }, responseType: "blob" });
}

export const putCalendarTimeRange = (calendarTimerangeData: ICalendarDialogFormData) => {
    return axios.put(HOST + MODULE + PUT_CALENDAR_TIMERANGE, calendarTimerangeData)
    .then(response => {
        return response;
    })
}

export const putUnvailableBayes = (unvailableBayes: ICalendarDialogFormData,type:CalendarViewType) => {
    let reqestContext = "?requestContext=";
    if(type===CalendarViewType.DRAFT){
        reqestContext=reqestContext+'draft';
    }else{
        reqestContext=reqestContext+'public';
    }
    return axios.put(HOST + MODULE + PUT_UNVAILABLE_BAYES+reqestContext, unvailableBayes)
    .then(response => {
        return response;
    })
}


export const bookSlot = (slots: ICalendarDialogFormData) => {
    return axios.put(HOST + MODULE + PUT_BOOK_SLOT,null, { params: { slotId: slots.slotId, service:slots.service,clientId:slots.clientId, contractId:slots.contractId, bioFlagStatus: slots.bioFlagStatus } })
    .then(response => {
        return response;
    })
}

export const getBayes = () => {
    return axios.get(HOST + MODULE + GET_BAYES)
    .then(response => {
        return response.data;
    })
}

export const getContractsSlot = (slotId:string) => {
    return axios.get(HOST + MODULE + GET_CONTRACTS_SLOT, { params: { slotId: slotId} })
    .then(response => {
        return response.data;
    })
}


export const getReservations = ()=>{
    return axios.get(HOST + MODULE + GET_BOOKINGS)
    .then(response=>{
        return response;
    })
}

export const getReservation = (codeIup:string)=>{
    return axios.get(HOST + MODULE + GET_BOOKING, { params: { codeIup: codeIup} })
    .then(response => {
        return response.data;
    })
}

export const getBusinessVehicle = (codeIup:string,service?:number,transporterId?:string) => {
    const params: { codeIup: string, serviceId?: number, transporterId?: string } = { codeIup };
    if (service !== undefined) {
        params.serviceId = service;
    }
    if (transporterId) {
        params.transporterId = transporterId;
    }
    return axios.get(HOST + MODULE + GET_BUSINESS_VEHICLE, { params })
    .then(response => {
        return response.data;
    })
}

export const postBooking = (RequiredAction:ReservationPostType,formData:IBooking) => {
    return axios.post(HOST+MODULE+POST_BOOKING+'?RequiredAction='+RequiredAction,formData)
    .then(response=>{
        return response.data;
    });
}

export const changeStatus = (entityId:string,entityType:EntityType,newStatus:BadgeStatus,message:string)=>{
    let obj = {entityId:entityId,entityType:entityType,newStatus:newStatus,message:message};
    return axios.put(HOST+MODULE+CHANGE_STATUS, obj)
}

export const selectorAPI = (entityType:EntityType,entityId?:string,service?:number,transporterId?:string) => {
    const params: { entityType: EntityType, entityId?: string, serviceId?: number, transporterId?: string } = { entityType };

    if (entityId) {
        params.entityId = entityId;
    }
    if (service !== undefined) {
        params.serviceId = service;
    }
    if (transporterId) {
        params.transporterId = transporterId;
    }
    return axios.get(HOST+MODULE+SELECTOR,{params})
    .then(response=>{
        return response.data;
    });
}

export const getBusinessSettle = () => {
    return axios.get(HOST + MODULE + GET_BUSINESS_SETTLE)
    .then(response => {
        return response.data;
    })
}
export const getContractsSettle = (businessId:string) => {
    return axios.get(HOST + MODULE + GET_CONTRACTS_SETTLE , { params : { businessId: businessId }})
    .then(response => {
        return response.data;
    })
}


export const loadAddressesOptionsAPI = (transporterId:string) => {
    return axios.get(HOST+MODULE+LOAD_ADDRESSES_OPTIONS, { params: { transporterId: transporterId} })
    .then(response=>{
        return response.data;
    });
}

export const getCheckList = (codeIup:string) => {
    return axios.get(HOST+MODULE+CHECKLIST,{params:{codeIup:codeIup}})
    .then(response=>{
        return response.data;
    });
}

export const putCheckList = (formData: ICheckListData) => {
    return axios.put(HOST + MODULE + CHECKLIST, formData)
    .then(response => {
        return response;
    })
}

export const postCloneReservation = (formData:ICloneReservation) => {
    return axios.post(HOST+MODULE+POST_CLONE_RESERVATION,formData)
    .then(response=>{
        return response.data; 
    });
}



export const nonWorkingDaysCreate = (nonWorkingDaysData: ICalendarDialogFormData) => {
    return axios.post(HOST + MODULE + NON_WORKING_DAYS,  { type:-1, startDate: nonWorkingDaysData.startDate, endDate: nonWorkingDaysData.endDate, action:"create" } )
    .then(response => {
        return response;
    })
}

export const nonWorkingDaysDelete = (nonWorkingDaysData: ICalendarDialogFormData) => {
    return axios.post(HOST + MODULE + NON_WORKING_DAYS, { type:-1, startDate: nonWorkingDaysData.startDate, endDate: nonWorkingDaysData.endDate, action:"delete" } )
    .then(response => {
        return response;
    })
}